import { useCallback, useMemo } from 'react';

import type { CodeString } from '@/consts/codes';
import { useAddRecent, useRecents } from '@/modules/MD/api/settings/hooks';

interface RecentsStore {
  recentCodes: Set<string>;
  recentsLoading: boolean;
  isAddingRecent: boolean;
  addRecent: (code: CodeString | undefined) => Promise<void>;
}

export const useRecentsStore = (): RecentsStore => {
  const { data: recentsArray, isLoading: recentsLoading } = useRecents();
  const addRecentMutation = useAddRecent();

  const recentCodes = useMemo(() => new Set(recentsArray ?? []), [recentsArray]);
  const isAddingRecent = addRecentMutation.isPending;

  const addRecent = useCallback(
    async (code: CodeString | undefined): Promise<void> => {
      if (!code) return;
      try {
        await addRecentMutation.mutateAsync(code);
      } catch (error) {
        console.error('Error adding recent:', error);
      }
    },
    [addRecentMutation.mutateAsync]
  );

  return {
    recentCodes,
    recentsLoading,
    isAddingRecent,
    addRecent
  };
};
